import React from 'react'

const Account = () => {
  return (
    <div>
      <h2>My account information</h2>
      
    </div>
  )
}

export default Account;
